<template>
  <hm-content title="">
    <div class="add-goods-containers">
      <hm-step
        :steps="steps"
        :scroll="true"
        :step="currentStep"
        @scroll="windowScroll"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div class="pvw flex flex-warp">
          <div class="flex-4">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="140px"
            >
              <div id="base">1.基本信息</div>
              <el-form-item label="活动标题" prop="gameName">
                <el-input
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameName"
                  placeholder="请输入活动标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间段选择" prop="activityDate">
                <!--el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  v-model="ruleForm.activityDate"
                  type="datetimerange"
                  :picker-options="pickerOptions0"
                  align="right"
                  start-placeholder="活动开始时间"
                  end-placeholder="活动结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  class="mr10"
                ></el-date-picker-->
                <div>
                  开始时间：
                  <el-date-picker
                          disabled
                          v-model="ruleForm.activityDate[0]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          placeholder="开始时间"
                          size="small"
                          class="mr10"
                  >
                  </el-date-picker>
                </div>
                <div>
                  结束时间：
                  <el-date-picker
                          size="small"
                          :editable="false"
                          v-model="ruleForm.activityDate[1]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="'23:59:59'"
                          placeholder="结束时间"
                          :picker-options="pickerOptions0"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="活动分享文案" prop="gameShareContent">
                <el-input
                  :maxlength="30"
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameShareContent"
                  placeholder="请输入活动分享文案，30字以内"
                ></el-input>
              </el-form-item>
              <el-form-item label="背景音乐链接" prop="gameBgm">
                <el-input
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model="ruleForm.gameBgm"
                  placeholder="请输入音乐链接/音乐网络地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="主图：" prop="mainImgUrl">
                <my-upload
                  field="file"
                  @crop-success="cropSuccess"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show"
                  v-if="show"
                  noCircle
                  noSquare
                  :width="750"
                  :height="360"
                  :headers="{ 'X-Access-Token': $token }"
                  :params="{ fileDir: 'mallDecoration' }"
                  :url="$uploadUrl"
                  img-format="png"
                ></my-upload>
                <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :params="{ fileDir: 'mallDecoration' }"
                :headers="{ 'X-Access-Token': $token }"
                :width="750"
                :height="1334"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload> -->
                <el-button
                  type="primary"
                  size="small"
                  v-show="!listHeaderImgUrl"
                  @click="toggleShow"
                  >上传</el-button
                >
                <span class="form-tip"
                  >图片尺寸建议750x1334（最多上传一张）</span
                >
                <div class="priview" v-if="listHeaderImgUrl">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text"  @click="handleRemove">删除</el-button>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="活动规则说明" prop="gameRuleRemark">
                <hm-rich-editor
                  v-model="ruleForm.gameRuleRemark"
                  :html="ruleForm.gameRuleRemark"
                />
              </el-form-item>

              <el-form-item label="虚拟参与人数" prop="visualJoinNum">
                <span>在实际参与人数基础上增加</span
                ><el-input
                  type="number"
                  @mousewheel.prevent.native
                  style="width: 100px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.visualJoinNum"
                  placeholder="请输入数字"
                ></el-input
                >人
              </el-form-item>
              <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>

              <el-form-item label="秒杀场次" prop="screening">
                <template>
                  <el-select
                    disabled
                    clearable
                    class="mr10 "
                    size="small"
                    v-model="screening"
                    placeholder="请选择场次"
                  >
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="4" value="4"></el-option>
                    <el-option label="5" value="5"></el-option>
                    <el-option label="6" value="6"></el-option>
                    <el-option label="7" value="7"></el-option>
                    <el-option label="8" value="8"></el-option>
                    <el-option label="9" value="9"></el-option>
                    <el-option label="10" value="10"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item prop="drawTypeDate">
                <div v-for="(item, index) in rule.seckillRuleList" :key="index">
                  <span>场次{{ index + 1 }} </span>
                  <el-date-picker
                    @change="dateUpdate"
                    disabled
                    :default-time="['00:00:00', '23:59:59']"
                    type="datetimerange"
                    v-model="rule.seckillRuleList[index].activityDate"
                    align="right"
                    start-placeholder="活动开始时间"
                    end-placeholder="活动结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                  ></el-date-picker>
                </div>
              </el-form-item>
              <div>
                <el-form-item label="是否在商城显示限购数" prop="drawTypeList" label-width="200">
                  <el-switch class="reward"
                             v-model="ruleForm.restrictionsShowState"
                             active-color="#2d8"
                             inactive-color="#ff4949"
                             active-text="显示"
                             inactive-text="隐藏"
                             active-value="yes"
                             inactive-value="no"
                  ></el-switch>
                </el-form-item>
<!--                <el-form-item label="是否在商城显示剩余库存数" prop="drawTypeList" label-width="200">-->
<!--                  <el-switch class="reward"-->
<!--                             v-model="ruleForm.remainStockShowState"-->
<!--                             active-color="#2d8"-->
<!--                             inactive-color="#ff4949"-->
<!--                             active-text="显示"-->
<!--                             inactive-text="隐藏"-->
<!--                             active-value="yes"-->
<!--                             inactive-value="no"-->
<!--                  ></el-switch>-->
<!--                </el-form-item>-->
              </div>
              <el-form-item label="添加商品" prop="drawTypeList">
                <el-table
                  :data="rule.seckillGoodsRuleList"
                  row-key="wxshopSkuId"
                  border
                  stripe
                  style="width: 100%"
                  :header-cell-style="{
                    background: '#f7f7f7',
                    color: '#606266'
                  }"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="商品货号"
                    show-overflow-tooltip
                  >
                    <!-- <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.goodsSn"
                        placement="top"
                        :disabled="!scope.row.goodsSn"
                      >
                        <el-input
                          clearable
                          style="width:120px"
                          @focus="inputChange"
                          v-model.trim="scope.row.goodsSn"
                          size="small"
                          placeholder="商品货号"
                        ></el-input>
                      </el-tooltip>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="wxshopSpuName"
                    label="商品名称"
                    show-overflow-tooltip
                  >
                    <!-- <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.wxshopSpuName"
                        placement="top"
                        :disabled="!scope.row.wxshopSpuName"
                      >
                        <el-input
                          clearable
                          @focus="inputChange"
                          style="width:120px"
                          v-model.trim="scope.row.wxshopSpuName"
                          size="small"
                          placeholder="商品名称"
                        ></el-input>
                      </el-tooltip>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="specIdGroupName"
                    label="商品规格"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.specIdGroupName"
                        placement="top"
                        :disabled="!scope.row.specIdGroupName"
                      >
                        <div>
                          {{ scope.row.specIdGroupName }}
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="eachPurchaseLimit"
                    label="单人限购"
                  >
                    <!-- <template slot-scope="scope">
                      <el-input
                        style="width:100px"
                        v-model.trim="scope.row.eachPurchaseLimit"
                        size="small"
                        @mousewheel.prevent.native
                        @input="
                          filterGt0OrFixed('eachPurchaseLimit', scope.$index)
                        "
                        clearable
                        placeholder="限购人数"
                      ></el-input>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="bargainTotalStockSum"
                    label="活动库存"
                  >
                    <template slot="header">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              content="活动库存与商品总库存无关"
                              placement="top"
                      >
                        <div class="text-center primary">活动库存</div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-input
                              :disabled="ruleForm.updateMode === 'no'"
                              style="width:100px"
                              v-model.trim="scope.row.bargainTotalStockSum"
                              size="small"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed('bargainTotalStockSum', scope.$index)
                        "
                              clearable
                              placeholder="活动库存"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="retailPrice"
                    label="零售价"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="seckillPrice"
                    label="秒杀价"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="roundSeqNumGroupArray"
                    label="参与场次"
                  >
                    <template slot="header">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="一个商品可以参加多个场次活动，上一场次活动未销售完可以进入下一场次"
                        placement="top"
                      >
                        <div class="text-center primary">参与场次</div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-select
                        style="width:100px"
                        multiple
                        clearable
                        disabled
                        size="small"
                        v-model="scope.row.roundSeqNumGroupArray"
                        placeholder="请选择场次"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="takeOrderDate"
                      label="提货时间"
                  >
                  </el-table-column>
                </el-table>
                <!-- <div class="table game-select">
                  <div class="table-header flex">
                    <div class="flex-1 text-center">商品货号</div>
                    <div class="flex-1 text-center">商品名称</div>
                    <div class="flex-1 text-center">单人限购</div>
                    <div class="flex-1 text-center">活动库存</div>
                    <div class="flex-1 text-center">零售价</div>
                    <div class="flex-1 text-center">秒杀价</div>
                    <div class="flex-1 text-center">参与场次</div>
                  </div>
                  <div class="table-body">
                    <div
                      class="flex table-row item-center"
                      v-for="(item, index) in rule.seckillGoodsRuleList"
                      :key="index"
                    >
                      <div class="flex-1 text-center">
                        <el-input
                          disabled
                          @focus="inputChange"
                          clearable
                          style="width:140px"
                          v-model.trim="item.goodsSn"
                          size="small"
                          placeholder="请选择商品货号"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          disabled
                          @focus="inputChange"
                          clearable
                          style="width:140px"
                          v-model.trim="item.wxshopSpuName"
                          size="small"
                          placeholder="请选择商品名称"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          maxlength="30"
                          disabled
                          type="number"
                          @mousewheel.prevent.native
                          style="width:130px"
                          v-model.trim="item.eachPurchaseLimit"
                          size="small"
                          @input="filterGt0OrFixed('eachPurchaseLimit', index)"
                          clearable
                          placeholder="请输入数字"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          maxlength="30"
                          disabled
                          type="number"
                          @mousewheel.prevent.native
                          style="width:130px"
                          v-model.trim="item.bargainTotalStockSum"
                          size="small"
                          clearable
                          @input="
                            filterGt0OrFixed('bargainTotalStockSum', index)
                          "
                          placeholder="请输入库存"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          maxlength="30"
                          disabled
                          type="number"
                          @mousewheel.prevent.native
                          style="width:130px"
                          v-model.trim="item.retailPrice"
                          size="small"
                          @input="filterGt0OrFixed2('retailPrice', index)"
                          placeholder="零售价"
                        ></el-input>
                      </div>

                      <div class="flex-1 text-center">
                        <el-input
                          maxlength="30"
                          disabled
                          type="number"
                          @mousewheel.prevent.native
                          style="width:130px"
                          v-model.trim="item.seckillPrice"
                          size="small"
                          @input="filterGt0OrFixed2('seckillPrice', index)"
                          placeholder="秒杀价"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-select
                          disabled
                          multiple
                          clearable
                          class="mr10 multiple-select"
                          size="small"
                          v-model="item.roundSeqNumGroupArray"
                          placeholder="请选择场次"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div> -->
              </el-form-item>

              <!-- <div id="gameAstrict">
                {{ steps.length === 3 ? 3 : 3 }}活动限制
              </div>
              <el-form-item label="配送方式限制" prop="expressModeGroup">
                <el-checkbox-group
                  v-model="threshold.expressModeGroup"
                  disabled
                >
                  <el-checkbox label="shop_extract">门店自提</el-checkbox>

                  <el-checkbox label="express_delivery">快递物流</el-checkbox>
                </el-checkbox-group>
              </el-form-item> -->
              <el-form-item label="配送方式限制" prop="expressModeGroups">
                <el-checkbox-group
                  v-model="ruleForm.expressModeGroups"
                  disabled
                >
                  <div>
                    <el-checkbox label="shop_extract">门店自提</el-checkbox>
                    <el-select
                      class="ml10"
                      clearable
                      multiple
                      v-model="ruleForm.shopIds"
                      placeholder="请选择可销售门店"
                      size="small"
                      filterable
                      disabled
                      v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                    >
                      <el-option label="全部门店" value="all"></el-option>
                      <el-option
                        :label="v.shopName"
                        :value="v.shopId"
                        v-for="(v, i) in microShopStoreList"
                        :key="i"
                      ></el-option>
                    </el-select>
                    <el-select
                        class="ml10"
                        clearable
                        multiple
                        v-model="ruleForm.shopIds"
                        placeholder="请选择可销售门店"
                        size="small"
                        filterable
                        disabled
                        v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                    >
                      <el-option label="全部门店" value="all"></el-option>
                      <el-option
                          :label="v.shopName"
                          :value="v.shopId"
                          v-for="(v, i) in dkMicroShopStoreList"
                          :key="i"
                      ></el-option>
                    </el-select>

                  </div>
                  <div>
                    <el-checkbox label="express_delivery">快递物流</el-checkbox>
                    <el-select
                      size="small"
                      v-model="ruleForm.expressId"
                      filterable
                      class="ml10"
                      clearable
                      placeholder="请选择运费模板"
                      disabled
                    >
                      <el-option
                        :label="v.expressName"
                        :value="v.expressId"
                        v-for="(v, i) in expressList"
                        :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <div class="flex flex-center">
                <el-button
                  type="primary"
                  size="small"
                  @click="submitForm('ruleForm')"
                  v-if="false"
                  >确认</el-button
                >
                <el-button size="small" @click="$router.back(-1)"
                  >返回</el-button
                >
              </div>
            </el-form>
          </div>
          <div class="text-center " style="width:120px">
            <el-button
              class="fixed-but"
              size="small"
              type="danger"
              round
              @click="minimum"
              v-if="isCollapse"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
            <el-button
              v-else
              class="fixed-but"
              size="small"
              type="primary"
              round
              @click="minimum"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
          </div>
          <div class="pvws" v-show="!isCollapse">
            <img
              style="width:100%"
              src="https://imgcdn.hemiao100.com/ThemePictures/miaosha1.png"
              alt=""
            />
          </div>
        </div>
      </el-scrollbar>
      <hm-filter-micro-shop-goods
        type="microShop"
        :visible="dialogVisible"
        :radio="isRadio"
        @saveGoods="saveGoods"
        @setLink="setLink"
        @close="dialogVisible = false"
      ></hm-filter-micro-shop-goods>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmCountdown from "@/components/HmCountdown";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMicroShopGoods,
    HmCountdown
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const actDate = function(rule, val, callback) {
      // if (val > +this.ruleForm.actMemberUpperLimit) {
      //   return callback(new Error("已报名人数不能大于活动人数上限"));
      // }
      if (
        this.ruleForm.activityDate &&
        !this.ruleForm.activityDate.length > 0
      ) {
        return callback(new Error("请选择活动时间段"));
      }
      const endTime = new Date(val[0]);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      if (leftTime < 0) {
        this.start = false;
      } else {
        this.start = true;
      }

      callback();
    }.bind(this);

    const patterndRemarkFunc = function(rule, val, callback) {
      if (!this.ruleForm.gameRuleRemark) {
        return callback(new Error("请输入活动规则说明"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeDateFunc = function(rule, val, callback) {
      this.rule.seckillRuleList.map(v => {
        if (!v.activityDate.length > 0) {
          return callback(new Error("请选择秒杀场次时间段"));
        }
      });
      callback();
    }.bind(this);
    const patterndMainImgUrlFunc = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeFunc = function(rule, val, callback) {
      if (this.screening) {
        callback();
      } else {
        return callback(new Error("请选择秒杀场次"));
      }
    }.bind(this);
    const patterndDrawTypeListFunc = function(rule, val, callback) {
      let flag = true;
      this.rule.seckillGoodsRuleList.map(v => {
        if (
          !v.goodsSn ||
          !v.eachPurchaseLimit ||
          !v.bargainTotalStockSum ||
          !v.retailPrice ||
          !v.seckillPrice ||
          !v.roundSeqNumGroupArray.length > 0
        ) {
          flag = false;
        }
        // for (let key in v) {
        //   if (!v[key] || !v.roundSeqNumGroupArray.length > 0) {
        //     flag = false;
        //   }
        // }
      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    return {
      storeCode: "",
      expressList: [],
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      start: true,
      endTime: "2019-11-11 18:12:00",
      type: false,
      isRadio: false,
      listHeaderImgUrl: "",
      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        activityDate: [],
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        visualJoinNum: "0",
        expressModeGroups: [],
        shopIds: [],
        expressId: "",
        restrictionsShowState: "",
        remainStockShowState: "",
      },
      screening: "",
      rule: {
        seckillRuleList: [
          {
            activityDate: "",
            roundSeqNum: "",
            roundStartTime: "",
            roundEndTime: ""
          }
        ],
        seckillGoodsRuleList: [
          {
            wxshopSpuName: "",
            goodsSn: "",
            eachPurchaseLimit: "",
            bargainTotalStockSum: "",
            retailPrice: "",
            seckillPrice: "",
            roundSeqNumGroupArray: ""
          }
        ]
      },
      threshold: {
        expressModeGroup: []
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            validator: patterndRemarkFunc,
            trigger: "blur"
          }
        ],
        activityDate: {
          validator: actDate,
          trigger: "blur",
          required: true
        },
        drawTypeDate: {
          trigger: "blur",
          validator: patterndDrawTypeDateFunc,
          required: true
        },
        screening: [
          {
            required: true,
            validator: patterndDrawTypeFunc,
            trigger: "blur"
          }
        ],
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        // estimatedNum: [
        //   {
        //     required: true,
        //     message: "请填写预计参与次数",
        //     trigger: "blur"
        //   }
        // ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ]
      },

      options: [
        {
          value: "1",
          label: "1"
        }
      ],
      actDesc: {},
      sole: Boolean,
      isCollapse: true
    };
  },
  computed: mapGetters(["microShopStoreList", "dkMicroShopStoreList"]),
  watch: {
    screening(val) {
      this.rule.seckillRuleList = [];
      this.rule.seckillGoodsRuleList = [
        {
          goodsSn: "",
          eachPurchaseLimit: "",
          bargainTotalStockSum: "",
          retailPrice: "",
          seckillPrice: "",
          roundSeqNumGroupArray: []
        }
      ];
      this.options = [];
      for (let i = 1; i <= val; i++) {
        this.rule.seckillRuleList.push({
          activityDate: "",
          roundSeqNum: "",
          roundStartTime: "",
          roundEndTime: ""
        });
        this.options.push({
          value: i,
          label: i
        });
      }
    },
    type(val) {}
  },
  created() {
    this.queryExpressList();
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    this.activityDetail();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    dateUpdate() {
      this.$forceUpdate();
    },
    async activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      const { result } = await this.$store.dispatch(
        "queryActivitDetail",
        params
      );
      result.expressModeGroups = result.expressModeGroups || [];
      result.shopIds = result.shopIds || [];
      this.screening = result.rule.seckillRuleList.length;
      setTimeout(() => {
        this.rule.seckillRuleList.forEach((v, i) => {
          result.rule.seckillRuleList.forEach(() => {
            this.rule.seckillRuleList[i].activityDate = [
              result.rule.seckillRuleList[i].roundStartTime,
              result.rule.seckillRuleList[i].roundEndTime
            ];
          });
        });
      }, 0);
      setTimeout(() => {
        for (let key in result) {
          this.ruleForm[key] = result[key];
        }
        this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
        this.listHeaderImgUrl = result.gameBgp;
        this.rule.seckillGoodsRuleList = result.rule.seckillGoodsRuleList;
        this.threshold = result.threshold;
      }, 0);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChild() {
      this.rule.seckillGoodsRuleList.push({
        goodsSn: "",
        eachPurchaseLimit: "",
        bargainTotalStockSum: "",
        retailPrice: "",
        seckillPrice: "",
        roundSeqNumGroupArray: []
      });
    },
    deleteChild(index) {
      this.rule.seckillGoodsRuleList.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";

          this.rule.seckillRuleList.forEach((v, i) => {
            v.roundSeqNum = i + 1;
            v.roundStartTime =
              v.activityDate && v.activityDate.length > 0
                ? v.activityDate[0]
                : "";
            v.roundEndTime =
              v.activityDate && v.activityDate.length > 0
                ? v.activityDate[1]
                : "";
          });

          let params = this.ruleForm;
          params.gameType = "seckill";
          params.gameBgp = this.listHeaderImgUrl;
          //   if (this.rule.screening == "daily") {
          //     this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
          //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
          //   } else {
          //     this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
          //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
          //   }

          params = Object.assign(params, {
            rule: this.rule,
            // threshold: this.threshold,
            gameId: this.$route.query.gameId
          });

          this.$store.dispatch("editActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    sample() {
      this.dialogVisible = true;
    },
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        if (this.rule.seckillGoodsRuleList.length === 1) {
          this.rule.seckillGoodsRuleList = [];
        }
        if (this.sole) {
          this.rule.seckillGoodsRuleList.splice(
            this.rule.seckillGoodsRuleList.length - 1,
            1
          );
        }
        data.map(v => {
          this.rule.seckillGoodsRuleList.push({
            wxshopSpuName: v.wxshopSpuName,
            goodsSn: v.goodsSn,
            eachPurchaseLimit: v.eachMemberPurchaseLimit,
            bargainTotalStockSum: v.stockNum,
            retailPrice: v.showPrice,
            seckillPrice: "",
            roundSeqNumGroupArray: []
          });
        });
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    filterGt0OrFixed(prop, i) {
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop]
        .replace(".", "")
        .replace("-", "");
      // this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop].replace(/^(0+)/, ""); //过滤0开头
      // this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop].replace(/[^\d]/g, ""); //仅保留数字
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      // this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop]
      //   .replace(".", "$#*")
      //   .replace(/\./g, "")
      //   .replace("$#*", "."); //去除其他"."
      // this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      // if (
      //   this.rule.seckillGoodsRuleList[i][prop].indexOf(".") < 0 &&
      //   this.rule.seckillGoodsRuleList[i][prop] != ""
      // ) {
      //   //首位是0的话去掉
      //   this.rule.seckillGoodsRuleList[i][prop] = parseFloat(
      //     this.rule.seckillGoodsRuleList[i][prop]
      //   );
      // }
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.rule.seckillGoodsRuleList[i][prop].indexOf(".") < 0 &&
        this.rule.seckillGoodsRuleList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.rule.seckillGoodsRuleList[i][prop] = parseFloat(
          this.rule.seckillGoodsRuleList[i][prop]
        );
      }
    },
    setLink(row) {
      // if (this.currentLinkIndex !== -1) {
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].goodsInfo = row;
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // } else {
      //   this.currentProp.goodsInfo = row;
      //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // }
      this.dialogVisible = false;
      this.isRadio = false;
    },

    batchSetting() {
      this.dialogVisible = true;
    },
    inputChange() {
      this.dialogVisible = true;
      this.sole = true;
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 120px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}
.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;
    background-color: #fff;
    // top: 200px;
    .commodityImg {
      width: 150px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .actcontent {
      width: 60%;
      height: 100px;
      margin-left: 20px;
      .activityTitle {
        font-size: 24px;
        font-weight: 700;
        margin-top: -2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2;
      }
      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }
      .originalCost {
        text-decoration: line-through;
        color: #c0c0c0;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }
    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }
    .describe {
      width: 100%;
      color: #ff5336;
      font-size: 17px;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 215px;
    }
  }
  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  // .rotate {
  //   -webkit-animation: rotating 1.2s linear infinite;
  //   -moz-animation: rotating 1.2s linear infinite;
  //   -o-animation: rotating 1.2s linear infinite;
  //   animation: rotating 1.2s linear infinite;
  // }
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
